import React from 'react'
import { localize } from '../../util/Localizer'

export const PassTooltip = () => {
  return <div className='tooltipContainer'>
    <p>{localize('common.tooltip.passPrompt1')}</p>
    <ul>
      <li>{localize('common.tooltip.passItem1')}</li>
      <li>{localize('common.tooltip.passItem2')}</li>
      <li>{localize('common.tooltip.passItem3')}</li>
    </ul>
    {/* <p>{localize('common.tooltip.passPrompt2')}</p> */}
  </div>
}

export const SingleLineTooltip = (props) => {
  return (
    <div className='tooltipContainer'>
      <p>{localize(props.txt)}</p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/widgets/common/Tooltip.js